import PetReview from "../../components/organisms/Pet-Insurance/review";

const PetReviewPage = (props) => {
  return <PetReview />
};

export default PetReviewPage;
